import { render } from "./AdGroupTypes.vue?vue&type=template&id=4be0eb36&scoped=true"
import script from "./AdGroupTypes.vue?vue&type=script&lang=js"
export * from "./AdGroupTypes.vue?vue&type=script&lang=js"

import "./AdGroupTypes.vue?vue&type=style&index=0&id=4be0eb36&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be0eb36"]])

export default __exports__